export function CustomError({ message, ...rest }: any = {}) {
  return Object.assign(new Error(message), rest);
}
